import {useParams} from "react-router-dom";
import classes from "./ReleaseActivityPage.module.css";
import settingsClasses from "../PlatformSetting/Settings.module.css";
import {
    DEFAULT_COUNT_DOWN_TIME_LIMIT,
    EMAIL_NOTIFICATION_OPTIONS,
    MINIMUM_POLL_TIME_LIMIT,
    POLL_SHARE_MODE,
    POLL_TYPE,
    RELEASE_ACTIVITY_VIEW,
    SYNC_LMS_OPTIONS,
    USER_SETTINGS,
    YUJA_DROPDOWN_SIZE
} from "../../utils/constants";
import {ReactComponent as RELEASE_ICON} from "../../images/release_options_icon.svg";
import {ReactComponent as BACK} from "../../images/arrow-left-purple.svg"
import {ReactComponent as INFO_ICON} from "../../images/info_icon.svg"
import {ReactComponent as RELEASE_ENTIRELY_IMAGE} from "./images/release_entriely_image.svg"
import {ReactComponent as RELEASE_BY_QUESTION_IMAGE} from "./images/release_by_question_image.svg"
import {ReactComponent as RELEASE_SCHEDULED_IMAGE} from "./images/release_scheduled_image.svg"
import {ReactComponent as ARROW_RIGHT} from "../../images/arrow_right_black.svg";

import React, {useState} from "react";
import YuJaButton from "../../components/standardization/YuJaButton";
import {
    deCapitalizeWord,
    getShortName,
    isShareByQuestionActivity,
    notifyError,
    notifySuccess,
    transferUserSettings
} from "../../utils/helpers";
import { useTranslation } from "react-i18next";
import {YuJaDropdown} from "../../components/standardization/YuJaDropdown";
import {PollApiCalls} from "../../apis/PollApiCalls";
import {useLocalStorageNew} from "../../hooks/useLocalStorageNew";
import {YuJaTooltip} from "../../components/standardization/YuJaTooltip";
import {LTIApiCalls} from "../../apis/LTIApiCalls";
import TimeLimitInput from "../../components/TimeLimitInput";
import {useSynLMSConfiguration} from "../../hooks/useSynLMSConfiguration";
import {ReportApiCalls} from "../../apis/ReportApiCalls";
import YuJaDateTimePicker from "../../components/YuJaDateTimePicker";
import YuJaSwitch from "../../components/standardization/YuJaSwitch";
import {Button} from "@base-ui/react/button";
import YuJaSelect from "../../components/standardization/YuJaSelect";


export default function ViewReleaseOptions({setPageView, pollData, handleShareAll, handleOpen, resetPollData}) {
    const { t } = useTranslation();
    const {pollKey, pollCode} = useParams();
    const {editPublishedPollDataFromKey, publishPoll, updatePollDetails} = PollApiCalls();
    const {embedActivity, isLMSAuthorized} = LTIApiCalls();
    const {takeScreenshotsNew} = ReportApiCalls();
    const [, getSession] = useLocalStorageNew("session", {});
    const {getRedirectUrl} = useSynLMSConfiguration();
    const session = getSession();
    const {settings = {}, } = session;
    const userSettings = transferUserSettings(settings);

    const {poll={}, questions=[]} = pollData;

    const {share, pollShareMode, startTime, endTime, index2Pk, reminderTime, pollType} = poll;
    let shareModeOptionDisabled = pollShareMode !== POLL_SHARE_MODE.UNKNOWN;

    const [shareMode, setShareMode] = useState(pollType === POLL_TYPE.ATTENDANCE ? POLL_SHARE_MODE.SHARE_EACH : pollShareMode);
    // const [pollTimeLimit, setPollTimeLimit] = useState(
    //     pollType === POLL_TYPE.ATTENDANCE
    //         ? timeSecondsToCustomNew(poll.attendanceDuration)
    //         : timeSecondsToCustomNew(poll.pollTimeLimit)
    // );

    const [pollTimeLimit, setPollTimeLimit] = useState(
        pollType === POLL_TYPE.ATTENDANCE
            ? poll.attendanceDuration
            : (
                pollShareMode === POLL_SHARE_MODE.SCHEDULE
                    ? (!!poll.pollTimeLimit
                            ? poll.pollTimeLimit
                            : userSettings[USER_SETTINGS.POLL_DURATION]
                    )
                    : poll.pollTimeLimit
            )
    );

    const [pollCountDown, setPollCountDown] = useState(
        pollType !== POLL_TYPE.ATTENDANCE
            ? (!!poll.getReadyAllTimeLimit ? poll.getReadyAllTimeLimit : userSettings[USER_SETTINGS.POLL_COUNTDOWN])
            : 0
    );
    const [isUnlimitedTime, setIsUnlimitedTime] = useState(poll.manualEnd === "true" || poll.manualEnd === true);
    const getNow = () => {
        let now = new Date();
        const minutes = now.getMinutes();
        const minutesToAdd = 5 - (minutes % 5);
        now.setSeconds(0);
        now.setMilliseconds(0);
        now.setMinutes(minutes + minutesToAdd);
        return now.getTime();
    }

    const [startDate, setStartDate] = useState(
        startTime
            ? new Date(startTime)
            : new Date(getNow() + 1800 * 1000 )
    );
    const [endDate, setEndDate] = useState(
        endTime
            ? new Date(endTime)
            : new Date(getNow() + 1800 * 1000 + poll.pollTimeLimit * 1000)
    );
    const [notificationTime, setNotificationTime] = useState(
        !!reminderTime && reminderTime !== -1
            ? (new Date(startTime).getTime() - new Date(reminderTime).getTime()) / 1000
            : -1
    );
    const [enableNotification, setEnableNotification] = useState(notificationTime !== -1);
    const [isSubmitting, setIsSubmitting] = useState(false);
    // const [manualEnd, setManualEnd] = useState(poll.manualEnd === "true" || poll.manualEnd === true)



    const btnStyle = {width: 80, height: 35, display: "flex", alignItems: "center", justifyContent: "center"};


    const choosePollShareMode = (pollShareMode) => {

        if (!shareModeOptionDisabled) {
            setShareMode(pollShareMode);
        }
    }

    const embed = async () => {
        let isSuccess = await embedActivity(pollKey, pollCode);
        if (isSuccess) {
            let copy = JSON.parse(JSON.stringify(poll));
            copy.pollShareMode = shareMode;
            let isMultipleSlides = isShareByQuestionActivity(copy);
            takeScreenshotsNew(
                pollKey,
                pollCode,
                isMultipleSlides,
                Array.from({ length: questions.length }, (_, i) => ({ serialNo: i + 1 }))
            );
        }
    }

    const handleSubmit = async () => {
        let pollToAdd = { ...pollData };
        let timeLimit = isUnlimitedTime ? 0 : pollTimeLimit;

        setIsSubmitting(true);


        try {
            let authorized = await isLMSAuthorized();
            if (!authorized) {
                return;
            }

            if (pollType === POLL_TYPE.ATTENDANCE) {
                await embed();
                await handleOpen(timeLimit);
            } else if (shareMode === POLL_SHARE_MODE.SHARE_ALL) { // shareAll
                await embed();
                await handleShareAll(timeLimit, pollCountDown);
            } else if (shareMode === POLL_SHARE_MODE.SCHEDULE) { // schedule
                let isAlreadyStarted = new Date(startTime) < new Date();
                pollToAdd.pollKey = pollKey;
                pollToAdd.pollShareMode = POLL_SHARE_MODE.SCHEDULE;
                pollToAdd.manualEnd = false;


                let body = {};
                if (!startDate && !endDate) {
                    notifyError(t("schedule.missingStartEndTimeError"));
                    return;
                }
                if (endDate < startDate) {
                    notifyError(t("schedule.invalidEndDateError"));
                    return;
                }
                if (endDate < new Date()) {
                    notifyError(t("schedule.invalidEndTimeError"));
                    return;
                }
                if (!isAlreadyStarted && startDate < new Date()) {
                    notifyError(t("schedule.invalidStartTimeError"));
                    return;
                }
                if (endDate > startDate.getTime() + 30 * 24 * 60 * 60 * 1000) {
                    notifyError(t("schedule.startEndGapError"));
                    return;
                }
                body.startTime = startDate;
                body.endTime = endDate;

                if ((endDate - startDate) / 1000 < pollTimeLimit) {
                    notifyError(t("schedule.invalidTimeLimitError"));
                    return;
                }
                body.pollTimeLimit = pollTimeLimit;


                // const timeToStart = startDate - new Date();
                // if (notificationTime && timeToStart < notificationTime * 1000) {
                //     notifyError(PAST_NOTIFICATION_ERROR);
                //     return;
                // }
                body.reminderTime = notificationTime ? notificationTime : -1;
                body.shortName = getShortName();

                if (pollShareMode === POLL_SHARE_MODE.UNKNOWN) {
                    pollToAdd = {...pollToAdd, ...body}
                    await publishPoll(pollToAdd);
                } else {
                    await editPublishedPollDataFromKey(body, pollKey, pollCode);
                }
                notifySuccess(t("poll.pollUpdatedSuccess"))
                await embed();
                resetPollData(RELEASE_ACTIVITY_VIEW.RELEASE_VIEW);
            } else { // shareEach
                await updatePollDetails(pollKey, pollCode, {pollShareMode: POLL_SHARE_MODE.SHARE_EACH}, true);
                await embed();
                resetPollData(RELEASE_ACTIVITY_VIEW.RELEASE_VIEW);
            }
        } finally {
            setIsSubmitting(false);
        }

    };



    if (pollType === POLL_TYPE.ATTENDANCE) {
        return (
            <div className={classes.parentContainer}>
                <div className={classes.mainCard} style={{padding: 0, gap: 0}}>
                    <div className={classes.column} style={{padding: 20, flex: 1, minHeight: 0, overflowY: 'auto'}}>
                        <span
                            tabIndex={0}
                            style={{cursor: "pointer", display: "flex", alignItems: "center", width: "fit-content", marginBottom: 20}}
                            onClick={() => setPageView(RELEASE_ACTIVITY_VIEW.RELEASE_VIEW)}
                        >
                            <BACK style={{marginRight: 2}}/>
                            <span>{t("common.back")}</span>
                        </span>

                        <div className={classes.column} style={{alignSelf: "center", maxWidth: "min(900px, 100%)"}}>
                            <span className={classes.description} style={{marginTop: 35, marginBottom: 20}}>
                                {t("poll.releaseActivityOptionsDescription", {activityType: pollType === POLL_TYPE.ATTENDANCE ? deCapitalizeWord(t("attendance.label")) : deCapitalizeWord(t("poll.mergedModeText"))})}
                            </span>

                            <div className={classes.row}>
                                <div className={classes.column}>
                                    <div className={settingsClasses.settingLabel} id={"unlimited-attendance-time"}>{t("gradebook.attendanceLengthSettingText")}</div>
                                    <div className={settingsClasses.settingDescription}>{t("gradebook.attendanceLengthSettingDesc")}</div>
                                </div>
                                <div style={{flex: 1}}/>
                                <YuJaSwitch
                                    aria-label={t("gradebook.attendanceLengthSettingText")}
                                    checked={isUnlimitedTime}
                                    onChange={checked => {
                                        if (!!checked) {
                                            setPollTimeLimit(0);
                                        } else {
                                            setPollTimeLimit(!!poll.attendanceDuration
                                                ? poll.attendanceDuration
                                                : userSettings[USER_SETTINGS.ATTENDANCE_DURATION]);
                                        }
                                        setIsUnlimitedTime(checked);
                                    }}
                                />
                            </div>


                            {!isUnlimitedTime &&
                                <div className={classes.row} style={{gap: 20, alignItems: "end", marginTop: 15}}>
                                    <div className={classes.column} style={{flex: 1, minWidth: 0}}>
                                        <div className={settingsClasses.settingLabel}>{t("questionBuilder.attendanceTimeLimitText")}</div>
                                        <span className={settingsClasses.settingDescription}>
                                            {t("poll.participantTimeIntro", {activityType: pollType === POLL_TYPE.ATTENDANCE ? deCapitalizeWord(t("attendance.label")) : deCapitalizeWord(t("poll.mergedModeText"))})}
                                        </span>
                                    </div>
                                    <TimeLimitInput
                                        label={t("questionBuilder.attendanceTimeLimitText")}
                                        timeLimit={pollTimeLimit}
                                        setTimeLimit={(timeLimit) => {
                                            setPollTimeLimit(timeLimit);
                                            if (!timeLimit) {
                                                setIsUnlimitedTime(true);
                                            }
                                        }}
                                        unit={"HH:MM"}
                                    />
                                </div>
                            }
                        </div>


                    </div>

                    <div
                        className={classes.row}
                        style={{gap: 10, height: 65, width: "100%", padding: "0 20px", borderTop: "1px solid #D1D1D1"}}
                    >
                        <span style={{flex: 1}}/>
                        <YuJaButton
                            type={"secondary"}
                            style={btnStyle}
                            onClick={() => setPageView(RELEASE_ACTIVITY_VIEW.RELEASE_VIEW)}
                        >{t("common.cancel")}</YuJaButton>
                        <YuJaButton
                            disabled={!shareMode || shareMode === POLL_SHARE_MODE.UNKNOWN || isSubmitting}
                            style={btnStyle}
                            onClick={handleSubmit}
                        >
                            <span className={`${isSubmitting ? classes.precessingText : ""}`}>{t("navigation.releasePrefix").trim()}</span>
                        </YuJaButton>

                    </div>

                </div>
            </div>
        );
    }


    if (shareMode === POLL_SHARE_MODE.SCHEDULE) {
        let isStarted = startDate < new Date();
        let filteredReminderOptions = EMAIL_NOTIFICATION_OPTIONS.map(option => ({
            ...option,
            label: t(option.labelKey),
        }));


        const inCourse = !!index2Pk;

        return (
            <div className={classes.parentContainer}>
                <div className={classes.mainCard} style={{padding: 0, gap: 0}}>
                    <div className={classes.column} style={{padding: 20, flex: 1, minHeight: 0, overflowY: 'auto'}}>
                        <span
                            tabIndex={0}
                            style={{cursor: "pointer", display: "flex", alignItems: "center", width: "fit-content", marginBottom: 20}}
                            onClick={() => setPageView(RELEASE_ACTIVITY_VIEW.RELEASE_VIEW)}
                        >
                            <BACK style={{marginRight: 2}}/>
                            <span>{t("common.back")}</span>
                        </span>

                        <div className={classes.column} style={{alignSelf: "center", maxWidth: "min(900px, 100%)"}}>
                            <div
                                className={classes.row}
                                style={{
                                    alignSelf: "center",
                                    gap: 15,
                                    marginBottom: 35
                                }}
                            >
                                <span className={classes.plusIconWrapper}><RELEASE_ICON/></span>
                                <span className={classes.title}>
                                    {inCourse
                                        ? t("questionBuilder.scheduledReleaseOptionDescriptionWithEmail")
                                        : t("questionBuilder.scheduledReleaseOptionDescriptionWithoutEmail")
                                    }
                                </span>
                            </div>


                            <div className={classes.row} style={{flexWrap: "wrap", rowGap: 10, columnGap: 40}}>
                                <div className={classes.column} style={{flex: 1, minWidth: 150}}>
                                    <div className={settingsClasses.settingLabel}>{t("poll.dateAndTime")}</div>
                                    <div className={settingsClasses.settingDescription} >
                                        {t("poll.dateAndTimeDesc")}
                                    </div>
                                </div>


                                <div className={classes.row} style={{gap: 5}}>
                                    <YuJaDateTimePicker
                                        ariaLabel={t("accessibility.scheduledPollStartPicker")}
                                        date={startDate}
                                        minDate={new Date(getNow())}
                                        maxDate={endDate}
                                        onChange={value => {
                                            if (!!value) {
                                                setStartDate(value);
                                            } else {
                                                setStartDate(null);
                                            }
                                        }}
                                    />
                                    <ARROW_RIGHT/>
                                    <YuJaDateTimePicker
                                        ariaLabel={t("accessibility.scheduledPollEndPicker")}
                                        date={endDate}
                                        minDate={startDate}
                                        onChange={value => {
                                            if (!!value) {
                                                setEndDate(value);
                                            } else {
                                                setEndDate(null);
                                            }
                                        }}
                                    />
                                </div>


                            </div>


                            <div style={{height: 20}}/>

                            <div className={classes.row}
                                 style={{flexWrap: "wrap", rowGap: 10, columnGap: 40, alignItems: "end"}}>
                                <div className={classes.column} style={{flex: 1, minWidth: 150}}>
                                    <div className={settingsClasses.settingLabel}>{t("questionBuilder.pollTimeLimitText")}</div>
                                    <span className={settingsClasses.settingDescription}>
                                        {t("poll.participantTimeIntroSchedule")}
                                    </span>
                                </div>
                                <TimeLimitInput
                                    timeLimit={pollTimeLimit}
                                    setTimeLimit={setPollTimeLimit}
                                    minVal={MINIMUM_POLL_TIME_LIMIT}
                                    reachMinValErrorText={t("settings.minimumPollTimeLimitError")}
                                    unit={"HH:MM"}
                                />
                            </div>


                            {inCourse &&
                                <div className={classes.column} style={{gap: 10, position: "relative"}}>

                                    {!!isStarted &&
                                        <YuJaTooltip
                                            tooltipStyle={{minWidth: 200, maxWidth: 350}}
                                            text={t("questionBuilder.scheduledPollEmailNotificationDisabledReason")}
                                        >
                                            <div
                                                style={{
                                                    position: "absolute", top: 0, left: 0, right: 0, bottom: 0,
                                                    background: "#E6E6E6", opacity: 0.5,
                                                    cursor: "not-allowed", zIndex: 1
                                                }}
                                            />
                                        </YuJaTooltip>
                                    }
                                    <div className={classes.row} style={{marginTop: 20}}>
                                        <div className={classes.column}>
                                            <div className={settingsClasses.settingLabel}>{t("accessibility.emailNotificationsText")}</div>
                                            <div className={settingsClasses.settingDescription}>
                                                {t("poll.emailNotifyDesc")}
                                            </div>
                                        </div>

                                        <div style={{flex: 1}}/>

                                        <YuJaSwitch
                                            aria-label={t("accessibility.emailNotificationsText")}
                                            disabled={isStarted}
                                            checked={enableNotification}
                                            onChange={checked => {
                                                setEnableNotification(checked);
                                                if (checked) {
                                                    setNotificationTime(filteredReminderOptions[0].value);
                                                }
                                            }}
                                        />
                                    </div>

                                    {!!filteredReminderOptions.length && enableNotification &&
                                        <YuJaSelect
                                            ariaLabel={t("accessibility.emailNotificationsTimerText")}
                                            value={notificationTime === -1 ? "" : notificationTime}
                                            options={filteredReminderOptions}
                                            disabled={isStarted}
                                            onChange={val => setNotificationTime(val)}
                                        />
                                        // <YuJaDropdown
                                        //     containerStyle={{width: 120}}
                                        //     size={YUJA_DROPDOWN_SIZE.SMALL}
                                        //     data={filteredReminderOptions}
                                        //     value={notificationTime === -1 ? "" : notificationTime}
                                        //     disabled={isStarted}
                                        //     onChange={option => {
                                        //         setNotificationTime(option.value);
                                        //     }}
                                        //     placeholder={t("questionBuilder.notificationDropdownPlaceholder")}
                                        // />
                                    }
                                </div>
                            }


                        </div>
                    </div>


                    <div
                        className={classes.row}
                        style={{gap: 10, height: 65, width: "100%", padding: "0 20px", borderTop: "1px solid #D1D1D1"}}
                    >
                        <span style={{flex: 1}}/>
                        <YuJaButton
                            type={"secondary"}
                            style={btnStyle}
                            onClick={() => setPageView(RELEASE_ACTIVITY_VIEW.RELEASE_VIEW)}
                        >{t("common.cancel")}</YuJaButton>
                        <YuJaButton
                            style={btnStyle}
                            disabled={isSubmitting}
                            onClick={handleSubmit}
                        >
                            <span className={`${isSubmitting ? classes.precessingText : ""}`}>{t("common.schedule")}</span>
                        </YuJaButton>
                    </div>
                </div>
            </div>
        );
    }


    return (
        <div className={classes.parentContainer}>
            <div className={classes.mainCard} style={{padding: 0, gap: 0}}>
                <div className={classes.column} style={{padding: 20, flex: 1, minHeight: 0, overflowY: 'auto'}}>
                    <span
                        tabIndex={0}
                        style={{cursor: "pointer", display: "flex", alignItems: "center", width: "fit-content", marginBottom: 20}}
                        onClick={() => setPageView(RELEASE_ACTIVITY_VIEW.RELEASE_VIEW)}
                    >
                        <BACK style={{marginRight: 2}}/>
                        <span>{t("common.back")}</span>
                    </span>

                    <div className={classes.column} style={{alignSelf: "center", maxWidth: "min(900px, 100%)"}}>
                        <div
                            className={classes.row}
                            style={{
                                alignSelf: "center",
                                gap: 15,
                                marginBottom: 35
                            }}
                        >
                            <span className={classes.plusIconWrapper}><RELEASE_ICON/></span>
                            <h1 className={classes.title} style={{margin: 0}}>{t("poll.releaseMethodQuestion")}</h1>
                        </div>


                        {shareModeOptionDisabled &&
                            <div className={classes.disabledNotification} style={{marginTop: 20}}>
                                <INFO_ICON className={classes.infoIcon} style={{flexShrink: 0}}/>
                                <span>
                                    <span className={classes.title} style={{marginRight: 5}}>
                                        {t("questionBuilder.editingDisabled")}
                                    </span>
                                    <span>
                                        {t("poll.releaseOptionLocked")}
                                    </span>
                                </span>
                            </div>
                        }


                        <div style={{display: "flex", gap: 40}}>
                            <Button
                                disabled={shareModeOptionDisabled}
                                className={`
                                ${classes.releaseOptionCard} 
                                ${shareMode === POLL_SHARE_MODE.SHARE_ALL ? classes.active : ""}
                                ${shareModeOptionDisabled ? classes.disabled : ""}
                                `}
                                onClick={() => choosePollShareMode(POLL_SHARE_MODE.SHARE_ALL)}
                            >
                                <RELEASE_ENTIRELY_IMAGE style={{marginBottom: 15, flexShrink: 0}}/>
                                <span className={classes.title}
                                      style={{textAlign: "center"}}>{t("poll.releaseAllQuestions")}</span>
                                <span className={classes.description}
                                      style={{textAlign: "center"}}>{t("poll.releaseAllQuestionsDesc")}</span>
                            </Button>

                            <Button
                                disabled={shareModeOptionDisabled}
                                className={`
                                ${classes.releaseOptionCard} 
                                ${shareMode === POLL_SHARE_MODE.SHARE_EACH ? classes.active : ""}
                                ${shareModeOptionDisabled ? classes.disabled : ""}
                                `}
                                onClick={() => choosePollShareMode(POLL_SHARE_MODE.SHARE_EACH)}
                            >
                                <RELEASE_BY_QUESTION_IMAGE style={{marginBottom: 15, flexShrink: 0}}/>
                                <span className={classes.title}
                                      style={{textAlign: "center"}}>{t("poll.releaseQuestionByQuestion")}</span>
                                <span className={classes.description}
                                      style={{textAlign: "center"}}>{t("poll.releaseQuestionByQuestionDesc")}</span>
                            </Button>

                            <Button
                                disabled={shareModeOptionDisabled}
                                className={`
                                ${classes.releaseOptionCard} 
                                ${shareMode === POLL_SHARE_MODE.SCHEDULE ? classes.active : ""}
                                ${shareModeOptionDisabled ? classes.disabled : ""}
                                `}
                                onClick={() => choosePollShareMode(POLL_SHARE_MODE.SCHEDULE)}
                            >
                                <RELEASE_SCHEDULED_IMAGE style={{marginBottom: 15, flexShrink: 0}}/>
                                <span className={classes.title}
                                      style={{textAlign: "center"}}>{t("poll.scheduleRelease")}</span>
                                <span className={classes.description}
                                      style={{textAlign: "center"}}>{t("poll.scheduleReleaseDesc")}</span>
                            </Button>
                        </div>

                        {shareMode === POLL_SHARE_MODE.SHARE_ALL &&
                            <>
                                <span
                                    className={classes.description}
                                    style={{marginTop: 35, marginBottom: 20}}
                                >
                                    {t("poll.releaseActivityOptionsDescription", {activityType: pollType === POLL_TYPE.ATTENDANCE ? deCapitalizeWord(t("attendance.label")) : deCapitalizeWord(t("poll.mergedModeText"))})}
                                </span>

                                <div className={classes.row}>
                                    <div className={classes.column}>
                                        <div className={settingsClasses.settingLabel} >{t("gradebook.pollLengthSettingText")}</div>
                                        <div
                                            className={settingsClasses.settingDescription}>{t("gradebook.pollLengthSettingDesc")}</div>
                                    </div>
                                    <div style={{flex: 1}}/>


                                    <YuJaSwitch
                                        aria-label={t("gradebook.pollLengthSettingText")}
                                        checked={isUnlimitedTime}
                                        onChange={checked => {
                                            if (!!checked) {
                                                setPollTimeLimit(0);
                                            } else {
                                                setPollTimeLimit(!!poll.pollTimeLimit ? poll.pollTimeLimit : userSettings[USER_SETTINGS.POLL_DURATION]);
                                            }
                                            setIsUnlimitedTime(checked);
                                        }}
                                    />
                                </div>


                                {!isUnlimitedTime &&
                                    <div className={classes.row} style={{gap: 20, alignItems: "end", marginTop: 15}}>
                                        <div className={classes.column} style={{flex: 1, minWidth: 0}}>
                                            <div className={settingsClasses.settingLabel}>{t("questionBuilder.pollTimeLimitText")}</div>
                                            <span className={settingsClasses.settingDescription}>
                                                {t("poll.participantTimeIntro", {activityType: pollType === POLL_TYPE.ATTENDANCE ? deCapitalizeWord(t("attendance.label")) : deCapitalizeWord(t("poll.mergedModeText"))})}
                                            </span>
                                        </div>
                                        <TimeLimitInput
                                            label={t("questionBuilder.pollTimeLimitText")}
                                            timeLimit={pollTimeLimit}
                                            setTimeLimit={(timeLimit) => {
                                                setPollTimeLimit(timeLimit);
                                                if (!timeLimit) {
                                                    setIsUnlimitedTime(true);
                                                }
                                            }}
                                            unit={"HH:MM"}
                                        />
                                    </div>
                                }


                                <div className={classes.row} style={{marginTop: 20, gap: 20}}>
                                    <div className={classes.column} style={{flex: 1, minWidth: 0}}>
                                        <div className={settingsClasses.settingLabel}>{t("questionBuilder.countdownTimerLabel")}</div>
                                        <div className={settingsClasses.settingDescription}>
                                            {t("questionBuilder.pollCountdownTimerDescription")}
                                            {!getRedirectUrl(poll) && poll.syncLmsOption === SYNC_LMS_OPTIONS.LMS_API_SYNC &&
                                                <> {" " + t("questionBuilder.pollCountdownTimerEmphasis")}</>
                                            }

                                        </div>
                                    </div>

                                    <TimeLimitInput
                                        label={t("questionBuilder.countdownTimerLabel")}
                                        timeLimit={pollCountDown}
                                        setTimeLimit={(timeLimit) => {
                                            setPollCountDown(timeLimit);
                                        }}
                                        unit={"MM:SS"}
                                        minVal={DEFAULT_COUNT_DOWN_TIME_LIMIT}
                                        reachMinValErrorText={t("settings.minimumCountdownError")}
                                    />
                                </div>
                            </>
                        }
                    </div>


                </div>

                <div
                    className={classes.row}
                    style={{gap: 10, height: 65, width: "100%", padding: "0 20px", borderTop: "1px solid #D1D1D1"}}
                >
                    <span style={{flex: 1}}/>
                    <YuJaButton
                        type={"secondary"}
                        style={btnStyle}
                        onClick={() => setPageView(RELEASE_ACTIVITY_VIEW.RELEASE_VIEW)}
                    >{t("common.cancel")}</YuJaButton>
                    <YuJaButton
                        disabled={!shareMode || shareMode === POLL_SHARE_MODE.UNKNOWN || isSubmitting}
                        style={btnStyle}
                        onClick={handleSubmit}
                    >
                        <span className={`${isSubmitting ? classes.precessingText : ""}`}>{t("navigation.releasePrefix").trim()}</span>
                    </YuJaButton>

                </div>
            </div>
        </div>
    )
        ;
}